import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../store'

export interface OrderState {
  orderCurrencyList?: any
  orderPurchasesRealityList?: any
  orderPurchasesList?: any
  orderDetail?: any
  requestList?: any
  historyOrderList?: any
  billOfLadingCodeList?: any
}

const initialState: OrderState = {
  orderCurrencyList: {},
  orderPurchasesRealityList: {},
  orderPurchasesList: {},
  orderDetail: {},
  requestList: {},
  historyOrderList: {},
  billOfLadingCodeList: {},
}

export const orderDucks = createSlice({
  name: 'rate',
  initialState,
  reducers: {

    getListOrderCurrency: (state: RootState, action: PayloadAction<any>) => {
      state.orderCurrencyList = { loading: true, queryStr: action.payload }
    },
    getListOrderCurrencySuccess: (state, action: PayloadAction<any>) => {
      state.orderCurrencyList = { loading: false, ...action.payload }
    },
    getListOrderCurrencyFail: (state, action: PayloadAction<any>) => {
      state.orderCurrencyList = { loading: false, ...action.payload }
    },

    getListOrderPurchasesReality: (state: RootState, action: PayloadAction<any>) => {
      state.orderPurchasesRealityList = { loading: true, queryStr: action.payload }
    },
    getListOrderPurchasesRealitySuccess: (state, action: PayloadAction<any>) => {
      state.orderPurchasesRealityList = { loading: false, ...action.payload }
    },
    getListOrderPurchasesRealityFail: (state, action: PayloadAction<any>) => {
      state.orderPurchasesRealityList = { loading: false, ...action.payload }
    },

    getListOrderPurchases: (state: RootState, action: PayloadAction<any>) => {
      state.orderPurchasesList = { loading: true, queryStr: action.payload }
    },
    getListOrderPurchasesSuccess: (state, action: PayloadAction<any>) => {
      state.orderPurchasesList = { loading: false, ...action.payload }
    },
    getListOrderPurchasesFail: (state, action: PayloadAction<any>) => {
      state.orderPurchasesList = { loading: false, ...action.payload }
    },


    getDetailOrder: (state: RootState, action: PayloadAction<any>) => {
      state.orderDetail = { loading: true, id: action.payload }
    },
    getDetailOrderSuccess: (state, action: PayloadAction<any>) => {
      state.orderDetail = { loading: false, ...action.payload }
    },
    getDetailOrderFail: (state, action: PayloadAction<any>) => {
      state.orderDetail = { loading: false, ...action.payload }
    },

    getListRequest: (state: RootState, action: PayloadAction<any>) => {
      state.requestList = { loading: true, queryStr: action.payload }
    },
    getListRequestSuccess: (state, action: PayloadAction<any>) => {
      state.requestList = { loading: false, ...action.payload }
    },
    getListRequestFail: (state, action: PayloadAction<any>) => {
      state.requestList = { loading: false, ...action.payload }
    },
    
    getListHistoryOrder: (state: RootState, action: PayloadAction<any>) => {
      state.historyOrderList = { loading: true, queryStr: action.payload }
    },
    getListHistoryOrderSuccess: (state, action: PayloadAction<any>) => {
      state.historyOrderList = { loading: false, ...action.payload }
    },
    getListHistoryOrderFail: (state, action: PayloadAction<any>) => {
      state.historyOrderList = { loading: false, ...action.payload }
    },


    getListBillOfLadingCode: (state: RootState, action: PayloadAction<any>) => {
      state.billOfLadingCodeList = { loading: true, queryStr: action.payload }
    },
    getListBillOfLadingCodeSuccess: (state, action: PayloadAction<any>) => {
      state.billOfLadingCodeList = { loading: false, ...action.payload }
    },
    getListBillOfLadingCodeFail: (state, action: PayloadAction<any>) => {
      state.billOfLadingCodeList = { loading: false, ...action.payload }
    },

  },
})

// Action creators are generated for each case reducer function
export const {
  getListOrderCurrency,
  getListOrderCurrencySuccess,
  getListOrderCurrencyFail,

  getListOrderPurchasesReality,
  getListOrderPurchasesRealitySuccess,
  getListOrderPurchasesRealityFail,

  getListOrderPurchases,
  getListOrderPurchasesSuccess,
  getListOrderPurchasesFail,

  getDetailOrder,
  getDetailOrderSuccess,
  getDetailOrderFail,
  getListRequest,
  getListRequestSuccess,
  getListRequestFail,
  
  getListHistoryOrder,
  getListHistoryOrderSuccess,
  getListHistoryOrderFail,

  getListBillOfLadingCode,
  getListBillOfLadingCodeSuccess,
  getListBillOfLadingCodeFail,

} = orderDucks.actions

export default orderDucks.reducer
